import React from 'react';
import {sendCrewMemberVouchers} from "../../../services/api/crewMembers";
import {ajaxErrorHandler, defaultSuccess} from "../../../libs/utils";
import {Trans} from "react-i18next";
import CrewMemberZones from "../../admin/registrations/pages/CrewMemberZones";

const SendVouchersToCrewMemberButton = ({crewMember}) => {
    const sendVouchers = () => {
        sendCrewMemberVouchers(crewMember.id)
            .then(() => {
                defaultSuccess(
                    `Access and parking vouchers sent to ${crewMember.user.firstName} ${crewMember.user.lastName}.`
                );
            })
            .catch(ajaxErrorHandler);
    }

    return (
        <button
            type="button"
            className="btn btn-outline-primary m-btn btn-sm  m-btn--icon m--margin-left-5"
            onClick={sendVouchers}
        >
            <span>
                <i className="la la-send" />
                <span>
                    <Trans>Send vouchers</Trans>
                </span>
            </span>
        </button>
    )
}

export default SendVouchersToCrewMemberButton;
